export const currencies = [
  { value: "ZAR", label: "R South African Rand", symbol: "R" },
  { value: "USD", label: "$ Dollar", symbol: "$" },
  { value: "INR", label: "₹ Indian Rupee", symbol: "₹" },
  // { value: "EUR", label: "€ Euro", symbol: "€" },
  // { value: "AUD", label: "A$ Australian Dollar", symbol: "A$" },
  // { value: "CAD", label: "C$ Canadian Dollar", symbol: "C$" },
  // { value: "GBP", label: "£ British Pound", symbol: "£" },
  // { value: "CHF", label: "CHF Swiss Franc", symbol: "CHF" },
  // { value: "BHD", label: ".د.ب Bahraini Dinar", symbol: ".د.ب" },
  // { value: "KWD", label: "د.ك Kuwaiti Dinar", symbol: "د.ك" },
  // { value: "BSD", label: "B$ Bahamian Dollar", symbol: "B$" },
  // { value: "ARS", label: "$ Argentine Peso", symbol: "$" },
  // { value: "BBD", label: "BDS$ Barbadian Dollar", symbol: "Bds$" },
  // { value: "JPY", label: "¥ Japanese Yen", symbol: "¥" },
  // { value: "KYD", label: "CI$ Cayman Islands Dollar", symbol: "CI$" },
  // { value: "ALL", label: "L Albanian Lek", symbol: "L" },
  // { value: "AZN", label: "₼ Azerbaijani Manat", symbol: "₼" },
  // { value: "NZD", label: "$ New Zealand Dollar", symbol: "$" },
  // { value: "BDT", label: "৳ Bangladeshi Taka", symbol: "৳" },
  // { value: "BRL", label: "R$ Brazilian Real", symbol: "R$" },
  // { value: "BND", label: "B$ Brunei Dollar", symbol: "B$" },
  // { value: "CNY", label: "¥ Chinese Yuan", symbol: "¥" },
  // { value: "BAM", label: "KM Bosnian Convertible Mark", symbol: "KM" },
  // { value: "AMD", label: "֏ Armenian Dram", symbol: "֏" },
  // { value: "GIP", label: "£ Gibraltar Pound", symbol: "£" },
];


export const countryCodes = [
    { value: "+1", label: "+1 (United States)", code: "US" },
    { value: "+7", label: "+7 (Russia)", code: "RU" },
    { value: "+20", label: "+20 (Egypt)", code: "EG" },
    { value: "+27", label: "+27 (South Africa)", code: "ZA" },
    { value: "+30", label: "+30 (Greece)", code: "GR" },
    { value: "+31", label: "+31 (Netherlands)", code: "NL" },
    { value: "+32", label: "+32 (Belgium)", code: "BE" },
    { value: "+33", label: "+33 (France)", code: "FR" },
    { value: "+34", label: "+34 (Spain)", code: "ES" },
    { value: "+36", label: "+36 (Hungary)", code: "HU" },
    { value: "+39", label: "+39 (Italy)", code: "IT" },
    { value: "+40", label: "+40 (Romania)", code: "RO" },
    { value: "+41", label: "+41 (Switzerland)", code: "CH" },
    { value: "+43", label: "+43 (Austria)", code: "AT" },
    { value: "+44", label: "+44 (United Kingdom)", code: "GB" },
    { value: "+45", label: "+45 (Denmark)", code: "DK" },
    { value: "+46", label: "+46 (Sweden)", code: "SE" },
    { value: "+47", label: "+47 (Norway)", code: "NO" },
    { value: "+48", label: "+48 (Poland)", code: "PL" },
    { value: "+49", label: "+49 (Germany)", code: "DE" },
    { value: "+51", label: "+51 (Peru)", code: "PE" },
    { value: "+52", label: "+52 (Mexico)", code: "MX" },
    { value: "+53", label: "+53 (Cuba)", code: "CU" },
    { value: "+54", label: "+54 (Argentina)", code: "AR" },
    { value: "+55", label: "+55 (Brazil)", code: "BR" },
    { value: "+56", label: "+56 (Chile)", code: "CL" },
    { value: "+57", label: "+57 (Colombia)", code: "CO" },
    { value: "+58", label: "+58 (Venezuela)", code: "VE" },
    { value: "+60", label: "+60 (Malaysia)", code: "MY" },
    { value: "+61", label: "+61 (Australia)", code: "AU" },
    { value: "+62", label: "+62 (Indonesia)", code: "ID" },
    { value: "+63", label: "+63 (Philippines)", code: "PH" },
    { value: "+64", label: "+64 (New Zealand)", code: "NZ" },
    { value: "+65", label: "+65 (Singapore)", code: "SG" },
    { value: "+66", label: "+66 (Thailand)", code: "TH" },
    { value: "+81", label: "+81 (Japan)", code: "JP" },
    { value: "+82", label: "+82 (South Korea)", code: "KR" },
    { value: "+84", label: "+84 (Vietnam)", code: "VN" },
    { value: "+86", label: "+86 (China)", code: "CN" },
    { value: "+90", label: "+90 (Turkey)", code: "TR" },
    { value: "+91", label: "+91 (India)", code: "IN" },
    { value: "+92", label: "+92 (Pakistan)", code: "PK" },
    { value: "+93", label: "+93 (Afghanistan)", code: "AF" },
    { value: "+94", label: "+94 (Sri Lanka)", code: "LK" },
    { value: "+95", label: "+95 (Myanmar)", code: "MM" },
    { value: "+98", label: "+98 (Iran)", code: "IR" },
    { value: "+211", label: "+211 (South Sudan)", code: "SS" },
    { value: "+212", label: "+212 (Morocco)", code: "MA" },
    { value: "+213", label: "+213 (Algeria)", code: "DZ" },
    { value: "+216", label: "+216 (Tunisia)", code: "TN" },
    { value: "+218", label: "+218 (Libya)", code: "LY" },
    { value: "+220", label: "+220 (Gambia)", code: "GM" },
    { value: "+221", label: "+221 (Senegal)", code: "SN" },
    { value: "+222", label: "+222 (Mauritania)", code: "MR" },
    { value: "+223", label: "+223 (Mali)", code: "ML" },
    { value: "+224", label: "+224 (Guinea)", code: "GN" },
    { value: "+225", label: "+225 (Ivory Coast)", code: "CI" },
    { value: "+226", label: "+226 (Burkina Faso)", code: "BF" },
    { value: "+227", label: "+227 (Niger)", code: "NE" },
    { value: "+228", label: "+228 (Togo)", code: "TG" },
    { value: "+229", label: "+229 (Benin)", code: "BJ" },
    { value: "+230", label: "+230 (Mauritius)", code: "MU" },
    { value: "+231", label: "+231 (Liberia)", code: "LR" },
    { value: "+232", label: "+232 (Sierra Leone)", code: "SL" },
    { value: "+233", label: "+233 (Ghana)", code: "GH" },
    { value: "+234", label: "+234 (Nigeria)", code: "NG" },
    { value: "+235", label: "+235 (Chad)", code: "TD" },
    { value: "+236", label: "+236 (Central African Republic)", code: "CF" },
    { value: "+237", label: "+237 (Cameroon)", code: "CM" },
    { value: "+238", label: "+238 (Cape Verde)", code: "CV" },
    { value: "+239", label: "+239 (Sao Tome and Principe)", code: "ST" },
    { value: "+240", label: "+240 (Equatorial Guinea)", code: "GQ" },
    { value: "+241", label: "+241 (Gabon)", code: "GA" },
    { value: "+242", label: "+242 (Congo - Brazzaville)", code: "CG" },
    { value: "+243", label: "+243 (Congo - Kinshasa)", code: "CD" },
    { value: "+244", label: "+244 (Angola)", code: "AO" },
    { value: "+245", label: "+245 (Guinea-Bissau)", code: "GW" },
    { value: "+246", label: "+246 (British Indian Ocean Territory)", code: "IO" },
    { value: "+248", label: "+248 (Seychelles)", code: "SC" },
    { value: "+249", label: "+249 (Sudan)", code: "SD" },
    { value: "+250", label: "+250 (Rwanda)", code: "RW" },
    { value: "+251", label: "+251 (Ethiopia)", code: "ET" },
    { value: "+252", label: "+252 (Somalia)", code: "SO" },
    { value: "+253", label: "+253 (Djibouti)", code: "DJ" },
    { value: "+254", label: "+254 (Kenya)", code: "KE" },
    { value: "+255", label: "+255 (Tanzania)", code: "TZ" },
  ];
  

  export const ORG="CRM"
  